import { makeRootDialogEvent } from '../utils/events'

export type DialogEmits =
  | 'update:modelValue'
  | 'show'
  | 'hide'
  | 'shown'
  | 'hidden'
  | 'ok'
  | 'cancel'

const dialogStack = ref<string[]>([])
watch(
  dialogStack,
  (newVal) => {
    console.log(newVal)
  },
  { deep: true }
)

export class Dialog {
  static use(
    id: string,
    props: { modelValue: boolean; hideParent?: boolean },
    emit: (ev: DialogEmits, val?: any) => void
  ) {
    const { modelValue, hideParent } = toRefs(props)
    const keepOnStack = hideParent?.value ?? true

    const openInternal = ref(false)

    const isOpen = computed({
      get() {
        return modelValue.value || openInternal.value
      },
      set(value: boolean) {
        openInternal.value = value
        emit('update:modelValue', value)
      }
    })

    const isTop = computed(() => _last(dialogStack.value) === id || !keepOnStack)

    const { $root } = useNuxtApp()

    function doEmits(ev: DialogEmits) {
      emit(ev)
      // @ts-ignore
      $root.emit(makeRootDialogEvent(ev, id))
    }

    const show = () => (isOpen.value = true)
    const hide = () => (isOpen.value = false)

    const emitShow = () => doEmits('show')
    const emitShown = () => doEmits('shown')
    const emitHide = () => doEmits('hide')
    const emitHidden = () => doEmits('hidden')
    const emitOk = () => doEmits('ok')
    const emitCancel = () => doEmits('cancel')

    watch(isOpen, (val, old) => {
      if (val !== old) {
        if (keepOnStack) {
          if (val) {
            dialogStack.value.push(id)
          } else {
            dialogStack.value.pop()
          }
        }
        const ev = val ? 'show' : 'hide'
        doEmits(ev)
      }
    })

    onMounted(() => {
      // @ts-ignore
      $root.on(`trigger:${makeRootDialogEvent('show', id)}`, (args?: any) => {
        show()
      })

      // @ts-ignore
      $root.on(`trigger:${makeRootDialogEvent('hide', id)}`, (args?: any) => {
        hide()
      })
    })

    onScopeDispose(() => {
      // @ts-ignore
      $root.off(`trigger:${makeRootDialogEvent('show', id)}`)
      // @ts-ignore
      $root.off(`trigger:${makeRootDialogEvent('hide', id)}`)
    })

    return {
      openInternal,
      isOpen,
      isTop,
      doEmits,
      show,
      hide,
      emitShow,
      emitShown,
      emitHide,
      emitHidden,
      emitOk,
      emitCancel
    }
  }
}
